const pagesLicensesEn = {
  add: {
    form: {
      navigation: {
        completed: {
          completedBy: 'Completed by:',
          continueAdding: 'Continue adding another license',
          goToLicense: 'Go to license',
          message: 'License added.',
          result: 'Result',
        },
        onPremises: {
          title: 'On-Premises',
        },
        step: {
          four: 'License scope & usage',
          one: 'General Identification',
          three: 'Key & Activation',
          two: 'License contract details',
        },
      },
      progressbar: {
        filled: 'filled',
        left: '{{value}}left',
        modeSetting: 'Mode Settings',
        mustItem: 'Must Item',
        mustItemOnly: 'Must item only',
        total: 'Total',
      },
      step1: {
        licensingSoftware: {
          name: {
            label: 'License Name',
            placeholder: 'Enter license name',
          },
          title: 'Licensing Software',
          vendorName: {
            label: 'Vendor',
            placeholder: 'Enter vendor name',
          },
        },
        next: 'License Contract Details',
        nextMustOnlyMode: 'License Scope & Usage',
        secondCard: {
          edition: {
            label: 'Edition / SKU',
            placeholder: 'Standard, Datacenter, ...',
          },
          platform: {
            label: 'Platform',
            placeholder: 'Windows, macOS, Linux, ...',
          },
          productVersion: {
            label: 'Product version',
            placeholder: '2012 R2, 10.0.17763, ...',
          },
        },
        title: 'General Identification',
      },
      step2: {
        firstCard: {
          licenseType: {
            label: 'License type',
            placeholder: 'Select license type',
          },
          purchaseChannel: {
            label: 'Purchase channel',
            placeholder: 'Enter purchase channel',
          },
          supportContract: {
            label: 'Support contract',
            placeholder: 'Enter support contract',
          },
        },
        next: 'Key & Activation',
        nextMustOnlyMode: 'License Scope & Usage',
        secondCard: {
          expirationDate: {
            label: 'License expiration date',
            placeholder: 'Select license expiration date',
          },
          purchaseDate: {
            label: 'Purchase/Agreement date',
            placeholder: 'Select purchase/agreement date',
          },
          renewalDate: {
            label: 'License renewal date',
            placeholder: 'Select license renewal date',
          },
          startDate: {
            label: 'License start date',
            placeholder: 'Select license start date',
          },
        },
        title: 'License Contract Details',
      },
      step3: {
        firstCard: {
          activationMethod: {
            label: 'Activation method',
            options: {
              AUTOMATIC: 'Automatic',
              MANUAL: 'Manual',
              SERVER_BASED: 'Server-based',
            },
            placeholder: 'Select activation method',
          },
          activationStatus: {
            label: 'Activation status',
            options: {
              ACTIVE: 'Active',
              EXPIRED: 'Expired',
              FAILED: 'Failed',
              PENDING: 'Pending',
              REVOKED: 'Revoked',
            },
            placeholder: 'Select activation status',
          },
          licenseKey: {
            label: 'License key',
            placeholder: 'Enter license key',
          },
          licensingServer: {
            label: 'Licensing server info',
            placeholder: 'Enter licensing server info',
          },
          managementTool: {
            label: 'Management tool',
            placeholder: 'Enter management tool',
          },
        },
        next: 'License Scope & Usage',
        nextMustOnlyMode: 'License Scope & Usage',
        title: 'Key & Activation',
      },
      step4: {
        firstCard: {
          allocationType: {
            label: 'Allocation type',
            options: {
              concurrentBased: 'Concurrent-based',
              deviceBased: 'Device-based',
              userBased: 'User-based',
            },
            placeholder: 'Select allocation type',
          },
          licenseMetric: {
            label: 'License metric',
            placeholder: 'Select license metric',
          },
          totalQuantity: {
            label: 'Total license quantity',
            placeholder: 'Enter total quantity',
          },
        },
        submit: 'Submit',
        title: 'License Scope & Usage',
      },
    },
    intro: {
      body: {
        fillOutDetails: 'Fill out details',
        itemCard: {
          licenseName: 'License Name',
          requiredDetails: 'Required Details',
          totalQuantity: 'Total quantity',
        },
        onPremises: {
          description: 'On-Premises',
          title: 'On-Premises',
        },
        selectLicenseType: 'Select licensing software types:',
      },
      header: {
        title: 'Add License',
      },
      options: {
        bulkCsvUpload: {
          button: 'Bulk CSV Upload',
          description:
            'You can add data for multiple licenses, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
          selectedLicenseType: 'Selected license type',
          title: 'Bulk CSV Upload',
        },
        description: 'Or you might want to...',
        syncIT: 'Sync with external service',
      },
    },
    pageTitle: 'Add License',
  },
  assignments: {
    assignButton: 'Assign License Sheet',
    licenseAction: {
      createUser: 'Create Account',
      createUserDialogDescription:
        'Are you sure you want to create an account for this user?',
      createUserDialogDescriptionWithProfile:
        'Are you sure you want to create an account with profile "{{profileName}}" for this user?',
      createUserDialogTitle: 'Create Account',
      createUserSuccess: 'Account created successfully',
      grant: 'Grant License',
      grantDialogDescription:
        'Are you sure you want to grant a license to this user?',
      grantDialogTitle: 'Grant License',
      grantSuccess: 'License granted successfully',
      revoke: 'Revoke License',
      revokeDialogDescription:
        'Are you sure you want to revoke the license from this user?',
      revokeDialogTitle: 'Revoke License',
      revokeSuccess: 'License revoked successfully',
    },
    searchPlaceholder: 'Search by name or email',
    tabs: {
      all: 'All',
      alumni: 'Alumni',
      following: 'Following',
      noLicense: 'No License',
      noUser: 'No User',
      violated: 'Violated',
      violatedSubGroup: 'Profile Mismatch',
    },
    userAssignmentDialog: {
      accountLabel: 'Account to assign',
      accountSearchPlaceholder: 'Search account',
      assignmentError: 'Failed to assign account',
      softwareLabel: 'Linked Software',
      title: 'Assign license sheet to {{licenseName}}',
    },
  },
  columns: {
    license: {
      noSuiteName: 'No suite name',
    },
  },
  common: {
    copiedToClipboard: 'Copied to clipboard!',
    renewalCycle: {
      ANNUAL: 'Annual',
      MANUAL: 'Manual',
      MONTHLY: 'Monthly',
      PERPETUAL: 'Perpetual',
    },
  },
  detail: {
    contractDetails: {
      expirationDate: 'License expiration date',
      licenseType: 'License type',
      licenseTypeOptions: {
        annual: 'Annual',
        manual: 'Manual',
        monthly: 'Monthly',
        perpetual: 'Perpetual',
      },
      purchaseAgreementDate: 'Purchase/Agreement date',
      purchaseChannel: 'Purchase channel',
      renewalDate: 'Renewal date',
      startDate: 'License start date',
      supportContract: 'Support/Maintenance contact',
      title: 'License Contract Details',
    },
    generalIdentification: {
      editionSku: 'Edition / SKU',
      licenseCategory: 'License Category',
      licenseCategoryOptions: {
        cloud: 'Cloud',
        onPremise: 'On-Premise',
      },
      name: 'License name',
      platform: 'Platform',
      productVersion: 'Product Version',
      softwareName: 'Software name',
      title: 'General Identification',
      vendor: 'Vendor',
    },
    header: {
      assigned: 'Assigned/Total',
      noRenewalDate: 'No renewal date',
      renewalDate: 'Renewal date',
      status: 'Status',
    },
    keyActivation: {
      activationMethod: 'Activation method',
      activationMethodOptions: {
        AUTOMATIC: 'Automatic',
        MANUAL: 'Manual',
        SERVER_BASED: 'Server-based',
      },
      activationStatus: 'Activation status',
      activationStatusOptions: {
        ACTIVE: 'Active',
        EXPIRED: 'Expired',
        FAILED: 'Failed',
        PENDING: 'Pending',
        REVOKED: 'Revoked',
      },
      licenseKey: 'License key',
      licensingServerInfo: 'Licensing server info',
      managementToolInfo: 'Management tool info',
      title: 'Key Activation',
    },
    scopeUsage: {
      availableQuantity: 'Available quantity',
      licenseMetric: 'License metric',
      licenseMetricOptions: {
        concurrentBased: 'Concurrent-based',
        deviceBased: 'Device-based',
        userBased: 'User-based',
      },
      title: 'Scope Usage',
      totalQuantity: 'Total quantity',
      usedQuantity: 'Used quantity',
    },
    sections: {
      auxiliaryFields: 'Auxiliary Fields',
      complianceAudit: 'Compliance & Audit',
      generalIdentification: 'General Identification',
      keyActivation: 'Key & Activation',
      licenseContractDetails: 'License Contract Details',
      licenseScopeUsage: 'License Scope & Usage',
    },
    statusBadge: {
      active: 'Active',
      all: 'All',
      expired: 'Expired',
      failed: 'Failed',
      inactive: 'Inactive',
      pending: 'Pending',
      revoked: 'Revoked',
    },
    toast: {
      licenseUpdated: 'License updated successfully',
      licenseUpdatedTitle: 'License updated',
    },
  },
  detailDevices: {
    assignButton: 'Assign License',
    deviceAssignmentDialog: {
      assignButtonLabel: 'Assign',
      assignmentError: 'Failed to assign device',
      cancelButtonLabel: 'Cancel',
      deviceSearchPlaceholder: 'Search devices',
      devicesLabel: 'Devices',
      minDevicesRequired: 'Please select at least one device',
      note: 'Note',
      title: 'Assign Device',
    },
    pageTitle: 'License Devices',
    tabs: {
      assigned: 'Assigned',
    },
  },
  detailPeople: {
    assignButton: 'Assign License',
    deviceAssignmentDialog: {
      assignButtonLabel: 'Assign',
      cancelButtonLabel: 'Cancel',
      deviceSearchPlaceholder: 'Search devices',
      devicesLabel: 'Devices',
      note: 'Note',
      title: 'Assign Device',
    },
    pageTitle: 'License People',
    tabs: {
      assigned: 'Assigned',
    },
  },
  devices: {
    unassign: 'Unassign',
    unassignDialog: {
      description:
        'Are you sure you want to unassign "{{deviceName}}" from this license?',
      successToast: 'Device unassigned successfully',
    },
  },
  inventory: {
    actions: {
      delete: 'Delete license',
      openMenu: 'Open menu',
    },
    addLicense: 'Add License',
    deleteLicenseDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Delete',
      description: 'Delete the following license.',
      successToast: 'License deleted successfully',
      title: 'Delete License',
      warning: 'This action cannot be undone.',
    },
    filterPlaceholder: 'Filter by name',
    pageTitle: 'License Inventory',
    tabs: {
      active: 'Active',
      all: 'All',
      awaiting: 'Awaiting',
      customSaas: 'Custom SaaS',
      expired: 'Expired',
      installed: 'Installed',
      mwOs: 'MW & OS',
      product: 'Product',
      saas: 'SaaS',
      scratch: 'Scratch',
    },
  },
  title: 'Licenses',
};

export default pagesLicensesEn;
